import React from 'react';
import { BmisDetail } from '@web/bmis/views/bmis-detail';
import { BmisList } from '@web/bmis/views/bmis-list';
import { ModuleName } from '@web/core/navigation/module-name';
import NoMatch from '@web/views/no-match';

export type BmisRoute = { path?: string; index?: boolean; element: React.ReactNode; moduleName?: ModuleName };

export const bmisRoutes: BmisRoute[] = [
    { index: true, element: <BmisList />, moduleName: ModuleName.Bmis },
    { path: ':rowGuid', element: <BmisDetail />, moduleName: ModuleName.Bmis },
    { path: '*', element: <NoMatch /> },
];
